import Component from '../../js/_Component';
import ResizeClasses from '../../js/util/_ResizeClasses';

export default class HeaderMenu extends Component {
	constructor(element: HTMLElement) {
		super(element);

		new ResizeClasses(this.element, {
			'm-stack': {
				max: 1024,
			},
			'm-condensed': {
				max: 512,
			},
		});

		this.element.addEventListener('resizeclassesapplied', () => {
			const condense = this.element.classList.contains('m-condensed');
			(this.element.querySelectorAll('.c-header-menu--item > *') as NodeListOf<HTMLElement>).forEach((item) => {
				item.dispatchEvent(new CustomEvent('updatecompactmode', {
					detail: condense,
				}));
			});
		});
	}
}

Component.register(HeaderMenu, 'HeaderMenu');
